import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {SearchBoxTitleComponent} from '../search-box-title/search-box-title.component';
import {ISearchSuggestion} from '../../../../services/game-search/game-search-result';
import {observer} from 'mobx-react';
import {SearchResultItemComponent} from '../search-result-item/search-result-item.component';
import {SearchLinksListBox} from "./boxes/search-links-list/search-links-list.box";

export interface SuggestedCategoriesComponentProps {
  title: string;
  className: string;
  items: ISearchSuggestion[];
}

@observer
export class SuggestedLinksComponent extends OrbitComponent<SuggestedCategoriesComponentProps>{

  private _renderSuggestedCategory(suggestedCategory: ISearchSuggestion) {
    return (
      <SearchResultItemComponent key={suggestedCategory.text} searchSuggestion={suggestedCategory}/>
    )
  }

  private _renderSuggestedCategories() {
    return this.props.items.map(suggestedCategory => this._renderSuggestedCategory(suggestedCategory))

}

  render() {
    if(this.props.items.length === 0) {
      return null;
    }

    return (
      <span className={this.props.className}>
        <SearchBoxTitleComponent title={this.props.title}/>
        <SearchLinksListBox className={'cy-suggested-links-list-box'}>
          {this._renderSuggestedCategories()}
        </SearchLinksListBox>
      </span>
    )
  }

}
